function isValid(field) {
  const helpText = field.parentNode.querySelector(".help-block");
  field.classList.remove("is-invalid");
  field.classList.add("is-valid");
  helpText && helpText.classList.add("d-none");
}

function isInvalid(field) {
  const helpText = field.parentNode.querySelector(".help-block");
  field.classList.remove("is-valid");
  field.classList.add("is-invalid");
  helpText && helpText.classList.remove("d-none");
}

function welcome() {
  const HOST_URL = (typeof window !== "undefined" && window.__IS_WHITELABEL__) ? window.location.origin : process.env.HOST_URL;
  const URL = `${HOST_URL}/api/v1/account/action`;

  let isSubmitAllowed = false;
  let field = undefined;

  const welcomeForm = $("#form-welcome");
  const welcomeBtn = $("#submit-welcome");
  if (!document.getElementById("form-welcome")) {
    return;
  }

  const businessType = document.querySelector(
    "#form-welcome select[name=businessType]",
  );
  const businessTypeInput = document.querySelector(
    "#form-welcome input[name=businessTypeInput]",
  );
  const designation = document.querySelector(
    "#form-welcome select[name=designation]",
  );
  const designationInput = document.querySelector(
    "#form-welcome input[name=designationInput]",
  );
  const manageAccount = document.querySelector(
    "#form-welcome select[name=manageAccount]",
  );
  const findUs = document.querySelector("#form-welcome textarea[name=findUs]");

  const onChange = (type) => {
    isSubmitAllowed = true;
    if (
      businessType.value === "- Select -" ||
      (businessType.value === "Other" && businessTypeInput.value === "")
    ) {
      isSubmitAllowed = false;
    } else {
      isValid(businessType);
    }
    if (
      designation.value === "- Select -" ||
      (designation.value === "Other" && designationInput.value === "")
    ) {
      isSubmitAllowed = false;
    } else {
      isValid(designation);
    }
    if (manageAccount.value === "- Select -") {
      isSubmitAllowed = false;
    } else {
      isValid(manageAccount);
    }
    if (findUs.value === "") {
      isSubmitAllowed = false;
    } else {
      isValid(findUs);
    }

    if (type === "businessType") {
      if (businessType.value == "Other") {
        businessTypeInput.classList.remove("d-none");
      } else {
        businessTypeInput.classList.add("d-none");
      }
    } else if (type === "designation") {
      if (designation.value == "Other") {
        designationInput.classList.remove("d-none");
      } else {
        designationInput.classList.add("d-none");
      }
    }
  };

  Array.from(welcomeForm[0].querySelectorAll("input")).forEach((field) => {
    const type = field.getAttribute("name");
    field.addEventListener("blur", onChange.bind(null, type));
  });

  Array.from(welcomeForm[0].querySelectorAll("select")).forEach((field) => {
    const type = field.getAttribute("name");
    field.addEventListener("change", onChange.bind(null, type));
  });

  Array.from(welcomeForm[0].querySelectorAll("textarea")).forEach((field) => {
    const type = field.getAttribute("name");
    field.addEventListener("blur", onChange.bind(null, type));
  });

  welcomeBtn.off("click");
  welcomeBtn.on("click", function (e) {
    e.preventDefault();
    if (this.disabled) {
      return;
    }
    this.disabled = true;

    let payload = {
      type: "GET_STARTED",
      meta: {
        businessType:
          businessType.value === "Other"
            ? businessTypeInput.value
            : businessType.value,
        designation:
          designation.value === "Other"
            ? designationInput.value
            : designation.value,
        numberOfSocialAccounts: manageAccount.value,
        message: findUs.value,
      },
    };

    console.log("payload", payload.meta);
    console.log("isSubmitAllowed", isSubmitAllowed);

    if (!isSubmitAllowed) {
      if (!field) {
        if (
          businessType.value === "- Select -" ||
          (businessType.value === "Other" && businessTypeInput.value === "")
        ) {
          isInvalid(businessType);
        }
        if (
          designation.value === "- Select -" ||
          (designation.value === "Other" && designationInput.value === "")
        ) {
          isInvalid(designation);
        }
        if (manageAccount.value === "- Select -") {
          isInvalid(manageAccount);
        }
        if (findUs.value === "") {
          isInvalid(findUs);
        }
        this.disabled = false;
        return;
      }
      const helpText = field.parentNode.querySelector(".help-block");
      field.classList.remove("is-valid");
      field.classList.add("is-invalid");
      helpText && helpText.classList.remove("d-none");
      this.disabled = false;
      return;
    }

    console.log("Submitting");

    const req = $.ajax({
      url: `${URL}`,
      method: "PATCH",
      data: JSON.stringify(payload),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
    });

    req.done((e) => {
      console.log("res", e);
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      if (e.data && e.data.redirectUrl) {
        location.href = e.data.redirectUrl;
      } else {
        location.reload();
      }
    });

    req.fail((e) => {
      this.disabled = false;
      console.log("e", e);
    });
  });
}

export default welcome;
